import "./assets/style.css";
import "./assets/animate.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import AppRoutes from "./routes/AppRoutes";
import ScrollToTop from "./components/layout/ScrollToTop";
import { ToastContainer } from "./utils/toast";
import { VehicleProvider } from "./hooks/VehicleContext";

window.bootstrap = bootstrap;

function App() {
  return (
    <VehicleProvider>
      <ScrollToTop />
      <AppRoutes />
      <ToastContainer />
    </VehicleProvider>
  );
}

export default App;
